import { render } from "./ModalPreviewFile.vue?vue&type=template&id=1dadfc54&scoped=true&ts=true"
import script from "./ModalPreviewFile.vue?vue&type=script&lang=ts"
export * from "./ModalPreviewFile.vue?vue&type=script&lang=ts"

import "./ModalPreviewFile.vue?vue&type=style&index=0&id=1dadfc54&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dadfc54"]])

export default __exports__